import { FormattedMessage } from 'components/shared/Intl';
import { LightAlert } from 'components/shared/LightAlert';
import type { IntlKey } from 'locales';

interface RequestAccessProps {
  e2e: string;
  url: string;
  labelKey: IntlKey;
}
export function RequestAccess({ e2e, url, labelKey }: RequestAccessProps) {
  return (
    <div className="w-100">
      <LightAlert severity="secondary" e2e={e2e}>
        <span className="flex-grow-1">
          <FormattedMessage
            id="discover.fetchData.requestAccess"
            values={{
              PortalLink: (
                <a href={url} className="text-link text-secondary" target="_blank">
                  <FormattedMessage id={labelKey} />
                </a>
              ),
            }}
          />
        </span>
      </LightAlert>
    </div>
  );
}
